module.exports = __webpack_public_path__ + "media/images/charactor2-426dfb540dc43bb79e31c0b6ee1e9bc1.png";